<div [class.content-container]="!isInProjectDetail">
    <div [class.document-preview]="!isInProjectDetail">
        <app-second-header
            *ngIf="!id"
            [headline]="headline"
            [searchBar]="false"
            [backLink]="'/einstellungen/dokumente'"
        >
            <button mat-stroked-button color="primary" routerLink="/einstellungen/dokumente">Abbrechen</button>
            <app-save-btn (save)="onSubmit()" [hasChanges]="hasChanges"></app-save-btn>
        </app-second-header>

        <div *ngIf="!id" class="ao-card big">
            <form [formGroup]="form">
                <div class="headline">
                    <h2>Dokument</h2>
                </div>

                <div class="grid">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Titel</mat-label>
                        <input type="text" matInput formControlName="name" maxlength="256" />
                        <mat-error *ngIf="form.get('name')?.getError('required')"> Pflichtfeld </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Kategorie</mat-label>
                        <mat-select formControlName="category">
                            <mat-option [value]="documentCategory.FORM_LETTER">Serienbrief</mat-option>
                            <mat-option [value]="documentCategory.THANK_YOU_LETTER">Dankesschreiben</mat-option>
                        </mat-select>

                        @if (form.get('category')?.getError('required')) {
                            <mat-error>Pflichtfeld</mat-error>
                        }
                    </mat-form-field>
                </div>
            </form>
        </div>

        <app-word-template
            [wordTemplate]="wordTemplate"
            (wordTemplateChange)="wordTemplateChanged($event)"
        ></app-word-template>
    </div>
</div>
